<template>
    <div>
        <div class="title-line">
            <slot name="TableTitle" /> 
            <div v-if="!isNotShowing">
                <el-row>
                    <!-- Update Mean -->
                    <el-tooltip class="item" effect="dark" content="Update Mean" placement="top">
                        <el-button size="mini" type="primary" icon="el-icon-cpu" circle @click="updateMeanValue()" />
                    </el-tooltip>

                    <!-- Refresh -->
                    <el-tooltip class="item" effect="dark" :content="$t('button.Refresh')" placement="top">
                        <el-button size="mini" type="success" icon="el-icon-refresh-right" circle @click="refreshTable()" />
                    </el-tooltip>

                    <!-- Update Status -->
                    <el-tooltip class="item" effect="dark" content="Update Status" placement="top">
                        <el-button size="mini" type="success" icon="el-icon-edit" circle @click="updateStatus()" />
                    </el-tooltip>

                    <!-- Export -->
                    <el-tooltip class="item" effect="dark" content="Export" placement="top">
                        <el-button size="mini" type="info" icon="el-icon-printer" circle @click="exportFileConfirmation()" />
                    </el-tooltip>

                    <!-- Delete -->
                    <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                        <el-button size="mini" type="warning" icon="el-icon-delete" circle @click="deleteMultiple()" />
                    </el-tooltip>

                    <!-- More -->
                    <el-tooltip class="item" effect="dark" content="Filter" placement="top">
                        <el-button size="mini" type="danger" icon="el-icon-s-operation" circle @click="openFilterDialog()" />
                    </el-tooltip>
                </el-row>
            </div>
        </div>
        <hr>
        <!-- <br v-if="(!TrialId && !ProgenyId) || !isNotShowing"> -->

        <!-- Raw Table -->
        <slot name="RawTable" />

        <general-dialog :dialog.sync="filterDialog" :header="filterHeader">
            <template #content>
                <el-select v-model="selectedTrial" placeholder="Trial" filterable clearable :disabled="checkIsHavingValue(TrialId)" class="filter-input">
                    <el-option
                        v-for="item in trialOpts"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                </el-select>

                <el-select v-model="selectedProgeny" placeholder="Progeny" filterable clearable :disabled="checkIsHavingValue(ProgenyId)" class="filter-input">
                    <el-option
                        v-for="item in progenyOpts"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                </el-select>

                <PalmNumberFilter class="filter-input" @handleInput="updatePalmNumber($event)" />

                <el-select v-model="SelectedFlagOpt" placeholder="Flag" filterable clearable class="filter-input">
                    <el-option
                        v-for="item in FlagOpts"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                </el-select>

                <el-select v-model="SelectedStatusOpt" placeholder="Status" filterable clearable class="filter-input">
                    <el-option
                        v-for="item in StatusOpts"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                </el-select>
				
                <!-- <el-date-picker
					v-if="tableCode == 'DERIVED_YIELD'"
					class="filter-input"
					v-model="selectedYear"
					type="year"
					placeholder="Year">
				</el-date-picker> -->

                <el-select v-model="selectedCreatorUser" placeholder="Creator User" filterable clearable class="filter-input">
                    <el-option
                        v-for="item in userOpts"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    />
                </el-select>

                <el-date-picker
                    v-if="tableCode != 'DERIVED_YIELD'"
                    v-model="dateFrom"
                    type="date"
                    placeholder="Record Date From"
                    class="filter-input"
                />

                <el-date-picker
                    v-if="tableCode != 'DERIVED_YIELD'"
                    v-model="dateTo"
                    type="date"
                    placeholder="Record Date To"
                    class="filter-input"
                />
				
                <el-date-picker
                    v-model="recordYearFrom"
                    type="year"
                    placeholder="Year From"
                    class="filter-input"
                />

                <el-date-picker
                    v-model="recordYearTo"
                    type="year"
                    placeholder="Year To"
                    class="filter-input"
                />

                <el-date-picker
                    v-model="creationDateFrom"
                    type="date"
                    placeholder="Creation Date From"
                    class="filter-input"
                />

                <el-date-picker
                    v-model="creationDateTo"
                    type="date"
                    placeholder="Creation Date To"
                    class="filter-input"
                />
            </template>

            <template #action>
                <v-btn color="agrinome_primary" class="v-btn-bold-color" dark @click="updateParams()">Apply</v-btn>
            </template>
        </general-dialog>

        <general-dialog :dialog.sync="exportDialog" :header="exportHeader">
            <template #content>
                <p>Are you sure to export the record(s)?</p>
            </template>
            <template #action>
                <v-btn color="agrinome_primary" class="v-btn-bold-color" dark @click="confirmExport($event)">Yes</v-btn>
            </template>
        </general-dialog>

        <general-dialog :dialog.sync="deleteDialog" :header="deleteHeader">
            <template #content>
                <p>Are you sure to delete the record(s)?</p>
            </template>
            <template #action>
                <v-btn color="agrinome_primary" class="v-btn-bold-color" dark @click="confimrDeleteMultiple($event)">DELETE</v-btn>
            </template>
        </general-dialog>

        <record-status-dialog 
            ref="recordDialog" 
            :table-id="TableId" 
            :api-info="ApiInfo" 
            :status-info="StatusInfo"
            :dialog.sync="dialog"
            :update-multiple="updateMultiple"
        />
    </div>
</template>

<script>

import SaveConfirmation from "@/smallComponents/Dialog/DialogContent/SaveConfirmation";
import DeleteConfirmation from "@/smallComponents/Dialog/DialogContent/DeleteConfirmation";
import PalmNumberFilter from "@/smallComponents/Form/PalmNumber";

export default {
    name: "RawDataTableBase",
    components: { PalmNumberFilter },
    props: ["StatusInfo", "TableId", "ApiInfo", "TrialId", "ProgenyId", "PalmId", "isNotShowing", "isDerivedData", "selectionRow", "exportInfo"],
    data() {
        return {
            activeName: 0,

            dialog: false,
            updateMultiple: false,
            selectedStatus: "OK",

            deleteDialog: false,
            deleteHeader: "Are you sure?",
				
            exportDialog: false,
            exportHeader: "Are you sure?",
				
            filterDialog: false,
            filterHeader: "Filter",

            FlagOpts: [
                { name: "Pass", value: false },
                { name: "Flagged", value: true }
            ],
            SelectedFlagOpt: null,

            StatusOpts: [
                { name: "OK", value: "OK" },
                { name: "R", value: "R" },
                { name: "KIV", value: "KIV" },
                { name: "-", value: "EMPTY" }
            ],
            SelectedStatusOpt: null,

            trialOpts: [],
            progenyOpts: [],
            userOpts: [],

            selectedTrial: null,
            selectedProgeny: null,
            selectedCreatorUser: null,
            selectedPalm: null,
            selectedYear: null,
				
            tooltipTitle: null,
            header: "Update the Status",

            dateFrom: null,
            dateTo: null,
				
            recordYearFrom: null,
            recordYearTo: null,

            creationDateFrom: null,
            creationDateTo: null,

            rowsSelectedIds: null,

            palmNumber: null,

            tableCode: null
        };
    },
    computed: {
        DateFromFormatted () {
            return this.dateFrom ? moment(this.dateFrom).format("DD MMMM YYYY") : "";
        },
        DateToFormatted () {
            return this.dateTo ? moment(this.dateTo).format("DD MMMM YYYY") : "";
        },
        YearFormatetd() {
            return this.selectedYear ? moment(this.selectedYear).format("YYYY") : "";
        },
        RecordYearFromFormatted() {
            return this.recordYearFrom ? moment(this.recordYearFrom).format("YYYY") : "";
        },
        RecordYearToFormatted() {
            return this.recordYearTo ? moment(this.recordYearTo).format("YYYY") : "";
        }
    },
    watch: {
        // selectedProgeny() {
        //     this.getAllTrial();
        // },
        // selectedTrial() {
        //     this.getAllProgeny();
        // },
    },
    mounted() {
        // var date = new Date();
        // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // this.dateFrom = moment(firstDay).format('YYYY-MM-DD');
        // this.dateTo = moment(lastDay).format('YYYY-MM-DD');
        this.$nextTick(function() {
            this.selectedTrial = this.TrialId || null;
            this.selectedProgeny = this.ProgenyId || null;
            this.selectedPalm = this.PalmId || null;
            // this.getAllTrial();
            // this.getAllProgeny();
            // this.getAllUsers();

            setTimeout(() => {
                this.tableCode = this.$slots["RawTable"][0].context.tableCode;
            }, 200);
        });
    },
    methods: {
        exportFileConfirmation() {
            this.exportDialog = true;
        },
        confirmExport() {
            var self = this;
            axios({
                method: "POST",
                url: this.exportInfo.exportUrl,
                data: {
                    trialId: this.selectedTrial,
                    progenyId: this.selectedProgeny,
                    palmId: this.selectedPalm,
                    hasFailChecking: this.SelectedFlagOpt,
                    status: this.SelectedStatusOpt,
                    recordDateFrom: this.DateFromFormatted,
                    recordDateTo: this.DateToFormatted,
                    RecordYearFrom: this.RecordYearFromFormatted,
                    RecordYearTo: this.RecordYearToFormatted,
                    year: this.YearFormatetd,
                    filter: this.exportInfo.searchValue,
                    sorting: this.exportInfo.sortValue,
                    creationTimeFrom: this.creationDateFrom,
                    creationTimeTo: this.creationDateTo,
                    creatorUserId: this.selectedCreatorUser,
                },
            }).then(function (response) {
                EventBus.$emit("snackBar", {
                    text: "File is being exported, please go to export page to check",
                    snackbarColor: "green darken-2"
                });
            });

            this.exportDialog = false;
        },
        checkIsHavingValue(value) {
            if (value) return true;
            else return false;
        },
        handleDateFromClear() {
            this.dateFrom = null;
            this.updateParams();
        },
        handleDateToClear() {
            this.dateTo = null;
            this.updateParams();
        },
        handleDateFromChange() {
            this.menuFrom = false;
            this.updateParams();
        },
        handleDateToChange() {
            this.menuTo = false;
            this.updateParams();
        },
        async getSelectedRow() {
            var row_selected = [];
            this.selectionRow.forEach(row => {
                row_selected.push(row.id);
            });
            return row_selected;
        },
        async updateStatus() {
            this.rowsSelectedIds = await this.getSelectedRow();

            if (this.rowsSelectedIds.length == 0) {
                EventBus.$emit("snackBar", {
                    text: "Please select at least one record to update",
                    snackbarColor: "amber darken-2"
                });
            }
            else {
                this.updateMultiple = true;
                this.dialog = true;
            }
        },
        refreshTable() {
            this.$emit("reloadTable");
        },
        updateMeanValue() {
            var self = this;
            if (this.TrialId || this.selectedTrial) {
                var trialId = this.TrialId || this.selectedTrial;
                axios({
                    method: "POST",
                    url: `CalculatedData/${this.ApiInfo.RepopulateMeanApi}`,
                    data: {
                        "trialId": trialId
                    },
                }).then(function (response) {
                    EventBus.$emit("snackBar", {
                        text: "Mean values updated",
                        snackbarColor: "green darken-2"
                    });
                    self.$emit("reloadTable");
                });
            }
            else {
                EventBus.$emit("snackBar", {
                    text: "Please select at least one trial to update mean",
                    snackbarColor: "amber darken-2"
                });
            }
				
        },
        async deleteMultiple() {
            this.rowsSelectedIds = await this.getSelectedRow();

            if (this.rowsSelectedIds.length == 0) {
                EventBus.$emit("snackBar", {
                    text: "Please select at least one record to delete",
                    snackbarColor: "amber darken-2"
                });
            }
            else {
                this.deleteDialog = true;
            }
        },
        confimrDeleteMultiple() {
            var self = this;
            this.deleteDialog = false;

            axios({
                method: "POST",
                url: `${this.ApiInfo.Table}/DeleteMany`,
                data: {
                    ids: self.rowsSelectedIds
                }
            }).then(function (response) {
                self.$emit("reloadTable");

                EventBus.$emit("snackBar", {
                    text: "Rows deleted",
                    snackbarColor: "green darken-2"
                });
            });
        },
        async cleanTable() {
            var self = this;
            if ($.fn.DataTable.isDataTable(self.TableId)) {   
                $(self.TableId).DataTable().destroy();
                $(self.TableId).empty();
                return true;
            }
        },
        updatePalmNumber(palmNumber) {
            this.palmNumber = palmNumber;
        },
        updateParams() {
            var self = this;
            var tempObj                   = {};
				    tempObj.TrialId           = this.selectedTrial;
				    tempObj.ProgenyId         = this.selectedProgeny;
				    tempObj.PalmId            = this.selectedPalm;
				    tempObj.SelectedFlagOpt   = this.SelectedFlagOpt;
				    tempObj.SelectedStatusOpt = this.SelectedStatusOpt;
				    tempObj.StartDate         = this.dateFrom;
				    tempObj.Year              = this.YearFormatetd;
				    tempObj.EndDate           = this.dateTo;
            tempObj.PalmNumber        = this.palmNumber;
            tempObj.RecordYearFrom    = this.RecordYearFromFormatted,
            tempObj.RecordYearTo      = this.RecordYearToFormatted,
				    tempObj.CreationTimeFrom  = this.creationDateFrom;
				    tempObj.CreationTimeTo    = this.creationDateTo;
				    tempObj.CreatorUserId     = this.selectedCreatorUser;
				
            this.$nextTick(function() {
                console.log("tempObj", tempObj);
                self.$emit("updateParam", tempObj);
                self.filterDialog = false;
            });
        },
        getAllTrial() {
            var self = this;
            axios({
                method: "GET",
                url: "Trial/GetAllForDropdown",
                params: {
                    ProgenyId: self.selectedProgeny
                }
            }).then(function (response) {
                self.trialOpts = response.data.result;
            });
        },
        getAllProgeny() {
            var self = this;
            axios({
                method: "GET",
                url: "Progeny/GetAllForDropdown",
                params: {
                    TrialId: self.selectedTrial
                }
            }).then(function (response) {
                self.progenyOpts = response.data.result;
            });
        },
        getAllUsers() {
            var self = this;
            axios({
                method: "GET",
                url: "User/GetAllForDropdown"
            }).then(function (response) {
                self.userOpts = response.data.result;
            });
        },
        openFilterDialog() {
            this.filterDialog = true;

            if (!this.trialOpts || this.trialOpts.length == 0) this.getAllTrial();
            if (!this.progenyOpts || this.progenyOpts.length == 0) this.getAllProgeny();
            if (!this.userOpts || this.userOpts.length == 0) this.getAllUsers();
        }
    }
};
</script>

<style lang="css" scoped>
.layout-container{
	margin: 0 -8px;
}
.layout-container .layout{
	margin: 0 8px;
}
.filter-input{
	width: 100%;
	margin-bottom: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmRawData/RawDataTableBase.vue